import { AxiosError } from 'axios';
import { BaseError } from 'viem';

export const errorToText = (error: unknown): string => {
  if (error instanceof BaseError) {
    return error.shortMessage || error.message;
  } else if (error instanceof AxiosError) {
    return (
      error.response?.data.message || error.response?.data?.msg || error.message
    );
  } else if (error instanceof Error) {
    return error.message;
  } else {
    try {
      return String(error) || 'Unknown error';
    } catch {
      return 'Unknown error';
    }
  }
};
